import { AppSlice, AreaSlice, ProductSlice } from '@/mobx/types';
import { cache, isBroswer } from '@/utils';
import { ProductTracker } from '@/utils/Tracker';
import { isDuringNowAfterDate } from '@/utils/date';
import { armsErrorSend } from '@/utils/libs/armsErrorSend';
import { decodeURIDecryptFE } from '@/utils/libs/JSEncrypt';
import { Base64 } from 'js-base64';
import { Component } from 'react';

interface ProductPageBaseProps {
  product: ProductSlice;
  area: AreaSlice;
  app: AppSlice;
}

/** 产品页的BaseClass */
class ProductPageBase extends Component<ProductPageBaseProps> {
  /** 增值服务页面check页面路径参数，判断是否立即弹出增值服务购买弹窗 */
  checkOpenBindServiceSerialModal = () => {
    if (!isBroswer) return;
    const { urlQuery, isMobile } = this.props.app;
    try {
      const {
        handleInsuranceService,
        productDetail: { commodities, id },
      } = this.props.product;
      // App 内H5购买 care，埋点上报，区分于运营后台超期购买的链接
      if (urlQuery?.sn && urlQuery?.from !== 'care_extend') {
        ProductTracker.commonTracker({
          category: `${isMobile ? 'mobile' : 'pc'}_product_page`,
          action: 'app_care_purchase_exposure',
          // @ts-expect-error coerce
          label: id,
        });
      }

      // 校验c参数必须在当前页面的套餐id中
      if (commodities.every((c) => `${c.id}` !== urlQuery.c)) return;
      // 解密信息
      const decodeSNCode = decodeURIDecryptFE(urlQuery.sn);
      const decodeEmployeeId = decodeURIDecryptFE(urlQuery.em);
      const decodeTime = Base64.decode(`${urlQuery.t}==`);

      // 来自运营后台超期购买的链接，少了一个参数都不行，而且有效期三天
      if (
        decodeSNCode &&
        decodeEmployeeId &&
        urlQuery.from === 'care_extend' &&
        urlQuery.t &&
        isDuringNowAfterDate(decodeTime, 3)
      ) {
        // 给信息打标，并且唤起弹窗
        cache.set(
          'care_extend_info',
          JSON.stringify({
            sn: decodeSNCode,
            t: decodeTime,
            pid: id,
            cid: urlQuery.c,
            remark: `sn码：${decodeSNCode}-工号：${decodeEmployeeId}-超期购买`,
          })
        );
        handleInsuranceService('inputSerial', decodeSNCode);
        handleInsuranceService('toggleModal', true);
      }
    } catch (e) {
      armsErrorSend(e as Error, { filename: 'productpage-checkOpenBindServiceSerialModal', data: { urlQuery } });
    }
  };
}

export default ProductPageBase;
